import { Platform, PlatformModule } from '@angular/cdk/platform';
import { CommonModule, DOCUMENT } from '@angular/common';
import { Inject, NgModule } from '@angular/core';

import { MediaQuery } from '../../services/media-query.service';
import { IconsModule } from '../icons/icons.module';
import { HtmlInputComponent } from './html-input.component';
import { InputComponent } from './input.component';
import { InputExtrasComponent } from './input-extras/input-extras.component';
import { InputFocusDirective } from './input-focus.directive';
import { InputResizeDirective } from './input-resize.directive';
import { NumberInputComponent } from './number-input.component';
import { TextInputComponent } from './text-input.component';

const exportedDeclarations = [
  InputComponent,
  TextInputComponent,
  HtmlInputComponent,
  InputFocusDirective,
  InputResizeDirective,
  NumberInputComponent,
];

@NgModule({
  imports: [IconsModule, CommonModule, InputExtrasComponent, PlatformModule],
  declarations: exportedDeclarations,
  exports: exportedDeclarations,
})
export class InputModule {
  constructor(
    @Inject(DOCUMENT) private document: Document,
    media: MediaQuery,
    platform: Platform,
  ) {
    this.setScrollbarWidthVariable(platform);
    media.mediaChanged.subscribe(() => {
      this.setScrollbarWidthVariable(platform);
    });
  }

  setScrollbarWidthVariable(platform: Platform) {
    if (platform.IOS || platform.ANDROID) {
      this.document.documentElement.style.setProperty('--scroll-width', `${0}px`);
      return;
    }
    const outer = this.document.createElement('div');
    outer.style.visibility = 'hidden';
    outer.style.overflow = 'scroll';
    outer.id = 'app-scroll';
    this.document.body.appendChild(outer);
    const inner = this.document.createElement('div');
    outer.appendChild(inner);
    const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;
    outer.parentNode?.removeChild(outer);
    this.document.documentElement.style.setProperty('--scroll-width', `${scrollbarWidth || 0}px`);
  }
}
